import { PageHeader } from '@fukuri-admins/ui/common';
import { getClientContractListLink } from '~/utils/getLinks';

type Props = {
  /**
   * パンくずに表示する利用企業名
   *
   * 「{clientName}の契約期間」形式で最後のパンくず要素に使用する
   */
  clientName: string;
};

/**
 * 企業契約期間 詳細ヘッダー Presentation コンポーネント
 *
 * breadcrumb: 企業契約期間 → {利用企業名}の契約期間（Figma: node-id 24490-60298）
 *
 * - PartnerAdmin は自パートナー前提のため、パートナー名のパンくずは不要（2 階層のみ）
 * - 編集・削除ボタンは表示しない（PartnerAdmin は契約期間を編集できない仕様）
 */
export const ClientContractTermDetailHeaderPresentation: React.FC<Props> = ({ clientName }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[
      { label: '企業契約期間', href: getClientContractListLink() },
      { label: `${clientName}の契約期間` },
    ]}
  />
);
